import React from "react";
import {
  Box,
  Typography,
  Grid2 as Grid,
  Card,
  IconButton,
} from "@mui/material";

import MedicationIcon from "@mui/icons-material/Medication";
import EditIcon from "@mui/icons-material/Edit";

const medications = [
  {
    name: "Empagliflozin 10 mg",
    sig: "Take 1 tablet once daily",
    status: "Active",
    prescribedBy: "Dr. Ross",
  },
  {
    name: "Losartan 50 mg",
    sig: "Take 1 tablet once daily",
    status: "Active",
    prescribedBy: "Dr. Ross",
  },
  {
    name: "Insulin Glargine",
    sig: "Inject 18 units nightly",
    status: "Active",
    prescribedBy: "Dr. Ross",
  },
  {
    name: "Rosuvastatin 10 mg",
    sig: "Take 1 tablet nightly",
    status: "Active",
    prescribedBy: "PCP",
  },
];

const EditBtn = () => (
  <IconButton
    size="small"
    sx={{
      border: "1px solid",
      borderColor: "grey.300",
      backgroundColor: "#fff",
      borderRadius: 2,
      p: 0.5,
      ml: 1,
      "&:hover": {
        backgroundColor: "grey.100",
      },
    }}
  >
    <EditIcon fontSize="small" sx={{ color: "grey.600" }} />
  </IconButton>
);

const StatusBadge = ({ status }) => {
  return (
    <Box
      px={1.5}
      py={0.5}
      borderRadius={5}
      sx={{
        backgroundColor: "#e6f4ea",
        color: "#2e7d32",
        fontSize: 13,
        fontWeight: 600,
      }}
    >
      {status}
    </Box>
  );
};

const MedicationItem = ({ med }) => {
  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 4,
        p: 2,
      }}
    >
      <Box display="flex" justifyContent="space-between">
        {/* Left */}
        <Box>
          <Typography fontWeight={600} mb={0.5}>
            {med.name}
          </Typography>

          <Typography color="text.primary" mb={0.5}>
            {med.sig}
          </Typography>

          <Typography variant="body2" color="text.secondary">
            Prescribed by: {med.prescribedBy}
          </Typography>
        </Box>

        {/* Right */}
        <Box display="flex" alignItems="center">
          <StatusBadge status={med.status} />
          <EditBtn />
        </Box>
      </Box>
    </Card>
  );
};

const MedicationsUI = () => {
  return (
    <Box p={2}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          {/* Header */}
          <Box display="flex" alignItems="center" gap={1} mb={2}>
            <MedicationIcon sx={{ color: "#2aa198" }} />
            <Typography fontWeight={600} color="#2aa198">
              Current Medications
            </Typography>
          </Box>

          {/* List */}
          <Box display="flex" flexDirection="column" gap={2}>
            {medications.map((med) => (
              <MedicationItem key={med.name} med={med} />
            ))}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MedicationsUI;
